/**
 * 路由配置文件
 *
 * @date 2019-04-29
 * @author chenyongzheng
 */

// 引入vue
import Vue from 'vue'

// 引入vue-router
import Router from 'vue-router'

// 通过中间件使用vue-router
Vue.use(Router);

// 定义路由路径map
const urlMap = new Map();

// 向路由路径中添加配置 添加的所有map对象都会成为home组件的子路由



// 人员管理
urlMap.set('/staffList', 'staff/StaffList.vue')
urlMap.set('/staffDetail', 'staff/StaffDetail.vue')
urlMap.set('/staffBasic', 'staff/StaffBasic.vue')
// 使用方式
urlMap.set('/usePatternList', 'product/UsePatternList.vue')
urlMap.set('/usePatternBasic', 'product/UsePatternBasic.vue')
// 弹药样式
urlMap.set('/ammunitionStyleList', 'product/AmmunitionStyleList.vue')
urlMap.set('/ammunitionStyleBasic', 'product/AmmunitionStyleBasic.vue')
// 弹药催化剂
urlMap.set('/catalystTypesList', 'product/CatalystTypesList.vue')
urlMap.set('/catalystTypesBasic', 'product/CatalystTypesBasic.vue')
// 装备种类
urlMap.set('/equipmentTypesList', 'product/EquipmentTypesList.vue')
urlMap.set('/equipmentTypesBasic', 'product/EquipmentTypesBasic.vue')
// 装备样式
urlMap.set('/equipmentStyleList', 'product/EquipmentStyleList.vue')
urlMap.set('/equipmentStyleBasic', 'product/EquipmentStyleBasic.vue')

// 作业弹药产品
urlMap.set('/ammunitionProductList', 'ammunitionProduct/AmmunitionProductList.vue')
urlMap.set('/ammunitionProductBasic', 'ammunitionProduct/AmmunitionProductBasic.vue')
// 装备样式
urlMap.set('/equipmentProductList', 'equipmentProduct/EquipmentProductList.vue')
urlMap.set('/equipmentProductBasic', 'equipmentProduct/EquipmentProductBasic.vue')
//生产火箭
urlMap.set('/production', 'production/ProductList.vue')

//装箱
urlMap.set('/packageBoxList', 'packageBox/PackageBoxList.vue')
//查询火箭
urlMap.set('/productDataList', 'productData/ProductDataList.vue')
urlMap.set('/enSaleDataList', 'enSaleData/EnSaleDataList.vue')
urlMap.set('/printProductQr', 'printProductQr/PrintProductQrList.vue')


// 将所有模块路径挂载到 Vue对象
Vue.prototype.$urlMap = urlMap;

// 定义常量子路由匿名函数 通过箭头函数的方式
const childRoute = () => {

    // 定义数据变量 以便保存路由
    let temp = [];

    // 遍历路由路径map
    urlMap.forEach((value, key) => {

        // 向数组中添加路径、模块
        temp.push({

            // 路径
            path: key,
            // 模块 使用懒加载方式 注意: 模块的路径必须拼接, 要不然 webpack找不到
            component: resolve => require([`@/views/${value}`], resolve)
        });
    });
    temp.push({

        // 路径
        path: "/printView",
        name: "printView",
        // 模块 使用懒加载方式 注意: 模块的路径必须拼接, 要不然 webpack找不到
        component: resolve => require([`@/views/print/PrintView.vue`], resolve)
    });
    // 返回数组
    return temp;
};

// 定义向外暴露路由模块
export default new Router({

    // 模式定义为浏览器环境
    mode: 'hash',

    // 定义全局路由
    routes: [

        // 如果url是'/' 重定向到login
        {
            path: '/',
            redirect: '/login'
        },

        // 登录页路由配置
        {
            path: '/login',
            component: resolve => require(['@/views/login/Login.vue'], resolve)

        },

        // 主展示区路由配置
        {
            path: '/home',
            component: resolve => require(['@/components/common/TheHome.vue'], resolve),
            children: childRoute()
        }

    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js